import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/Login'
import Company from '@/views/companies/CompanyList'
import Patient from '@/views/companies/PatientList'
import Dashboard from '@/views/Dashboard'
import Analytics from '@/views/Analytics'
import CompanyAnalytics from '@/views/CompanyAnalytics'
import Test from '@/views/Test'
import Main from '@/views/Main'
import Success from '@/views/Success'
import firebase from 'firebase'
import Results from '@/views/results/Results'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path:'*',
      redirect: '/dashboard'
    },
    {
      name: 'Login',
      path: '/login',
      component: Login,
      meta:{
        requiresGuest: true
      }
    },
    {
      name: 'Dashboard',
      path: '/dashboard',
      component: Dashboard,
      meta:{
        requiresAuth: true
      }
    },
    {
      name: 'Test',
      path: '/test',
      component: Test,
    },
    {
      name: 'Company',
      path: '/company',
      component: Company,
      meta:{
        requiresAuth: true
      }
    },
    {
      name: 'Patient',
      path: '/patient/:companyId',
      component: Patient,
      meta:{
        requiresAuth: true
      }
    },
    {
      name: 'Analytics',
      path: '/analytics/:companyId',
      component: Analytics,
      meta:{
        requiresAuth: true
      }
    },
    {
      name: 'CompanyAnalytics',
      path: '/analytics2/:companyId',
      component: CompanyAnalytics,
      meta:{
        requiresAuth: true
      }
    },
    {
      name: 'Results',
      path: '/companyId/:companyId/formsId/:formsId',
      component: Results,
      meta:{
        requiresAuth: true
      }
    },
    {
      name: 'Main',
      path:'/assessment/:companyId',
      component: Main
    },
    {
      name: 'Success',
      path:'/success',
      component: Success
    }
  ]
})

router.beforeEach((to, from, next) => {
  const currentUser = firebase.auth().currentUser;
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const requiresGuest = to.matched.some(record => record.meta.requiresGuest);
  if (requiresAuth){
    if(!currentUser){
      next('/login');
    }
    else{
      next();
    }
  }
  else if(requiresGuest){
    if(currentUser){
      next('/company');
    }
    else{
      next();
    }
  }
  else{
    next();
  }
})
export default router

